
import { IHashMap } from '@adaptiva/core/common';
import { Summarizable } from '@adaptiva/core/summary';
import { UiService } from '@adaptiva/core/ui';
import { BaseWidgetComponent, WidgetService } from '@adaptiva/core/widgets';
import { AuthoringPropertyTab, ICdnFile, MetadataAuthoringProperties, MetadataObject } from '@adaptiva/metadata/common';
import { TabsContainerComponent } from '@adaptiva/widgets/tabs';
import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IAuthoringPropertyOutput } from '../interfaces';
import { MetadataHistoryObjectRow } from '../metadata-history-object-table';

@Component({
	standalone: false,
	selector: 'ada-authoring-property-tabs',
	templateUrl: './authoring-property-tabs.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.ada-full-height]': 'true',
		'[class.ada-full-width]': 'true',
	},
	providers: [
		WidgetService,
		{ provide: BaseWidgetComponent, useExisting: forwardRef(() => AuthoringPropertyTabsComponent) }
	]
})
export class AuthoringPropertyTabsComponent<T extends MetadataAuthoringProperties> extends BaseWidgetComponent {

	@Input()
	public tabNames: AuthoringPropertyTab[];

	@Input()
	public editorClass: typeof Summarizable;

	@Input()
	public isInheritanceDisabled: boolean = false;

	/** @deprecated Appears to no longer be used */
	@Input()
	public serverObject: T;

	@Input()
	public serverObject$: BehaviorSubject<T>;

	@Input()
	public inheritedPropertyObject: IHashMap<any>;

	@Input()
	public availableProperties: BehaviorSubject<string[]>;

	@Input()
	public cdnUploadOptionsInstallation: BehaviorSubject<ICdnFile>;

	@Input()
	public cdnUploadOptionsRepair: BehaviorSubject<ICdnFile>;

	@Input()
	public cdnUploadOptionsUninstallation: BehaviorSubject<ICdnFile>;

	@Input()
	public targetPropertyMap: string = 'authoringProperties';

	@Output()
	public authoringPropertyChange: EventEmitter<IAuthoringPropertyOutput<MetadataObject>> = new EventEmitter();

	@Output()
	public objectReverted: EventEmitter<MetadataHistoryObjectRow> = new EventEmitter();

	@ViewChild(TabsContainerComponent)
	public tabsContainer: TabsContainerComponent;

	public defaultCardPadding: string = JSON.stringify(['1rem', '1rem', '1.25rem', '1rem']);

	constructor(public UI: UiService, public widgetService: WidgetService) {
		super(widgetService);
	}

	public setSelectedTab(_tab: int | string): void {
		this.tabsContainer.setSelectedTab(_tab);
	}

	public authoringPropertyChanged(_propertyObjectOutput: IAuthoringPropertyOutput<MetadataObject>): void {
		this.authoringPropertyChange.emit(_propertyObjectOutput);
	}

	public metadataObjectReverted(_metadataHistoryState: MetadataHistoryObjectRow): void {
		this.objectReverted.emit(_metadataHistoryState);
	}

}
